import { observable, action,computed} from 'mobx';
import Cell from './emptyCell';
import {finance, time} from '../index';
import Parent from './parent';
import settings from '../cultureSettings.json';

export default class Bunker extends Parent{

    @observable transportStack;
    @observable stackActive;
    @observable activeTransport;


    constructor(num, capacity, bunkerName='', culture = "None", amount=0, moistureLevel = 0 , wasteLevel =0,scenario =[],status='',bunkerType='truck'){
        super(num, culture, scenario, amount, moistureLevel, wasteLevel, status, bunkerName);
        this.totalCapacity = capacity;
        this.type = 'bunker';
        this.currentOperation = 1;
        this.bunkerType = bunkerType;
        this.stackActive = false;
        this.activeTransport = new Cell();
        this.transportStack = [0,0,0,0];
    }


    @action removeTransportFromStack(id){
        this.transportStack.splice(id,1);
        this.transportStack.push(0);
    }

    @action setActiveTransport(obj){
        this.activeTransport = obj;
    }

    @action addToStack(id, obj, del = 0){
        if(this.transportStack[id]){
            this.transportStack.splice(id,del,obj);
            this.transportStack.splice(4,1);
        }else{
            if(this.activeTransport.disabled && !this.transportStack[0]){
                this.activeTransport = obj;
            }else{
                this.transportStack[this.transportStack.findIndex(item=>!item)] = obj;
            }
        }
    }

    @action setTransportStack(id,obj){
        this.transportStack[id] = obj;
    }

    @action checkActiveTransport(){
        if(this.transportStack[0]){
            this.setActiveTransport(this.transportStack.shift());
            this.transportStack.push(0);
        }else{
            this.setActiveTransport(new Cell())
        }
    }

    @computed get getThumbs(){
        let result = [];
        this.transportStack.forEach((item)=>{
            if(item){
                result.push({culture: item.culture, number: item.groupQuantity})}});
        return result;
    }

   @action checkBunker(){
       this.checkUnit();
       if(!this.activeTransport.disabled && (this.activeTransport.culture === this.culture || this.culture==='None') && this.amount < this.totalCapacity){
           let transport = this.activeTransport;
           if ( this.culture === 'None') {
               super.setUnit(0,transport.culture, transport.moistureLevel, transport.wasteLevel);
           }

           let sum = Math.floor(settings[this.culture].volume * 2 * time.tickCoef*10)/10;
           sum = (transport.amount - sum <= 0 ? transport.amount : sum)
           let delta = Math.floor(this.totalCapacity * settings[this.culture].volume) - this.amount - sum;
           let rem = Math.floor(this.totalCapacity * settings[this.culture].volume) - this.amount;
           if(delta <= 0 ){
               this.filling(transport.culture,rem,transport.wasteLevel,transport.moistureLevel);
               finance.incParams('input',transport.culture,rem);
               transport.shipping(rem,this.bunkerType);
               if (transport.groupQuantity === 0) {
                   this.checkActiveTransport();
               }
           }else{
               this.filling(transport.culture,sum,transport.wasteLevel,transport.moistureLevel);
               finance.incParams('input',transport.culture,sum);
               transport.shipping(sum,this.bunkerType);
               if (transport.groupQuantity === 0) {
                   this.checkActiveTransport();
               }
           }
       }
    }
}

// if(delta<0){delta = 0}
// let rem = transport.amount - sum;
// if(delta < sum || rem < 0){
//     //please check this. WTF???
//     if (rem < 0 && rem <= delta && delta) {
//         this.filling(transport.culture,transport.wasteLevel,transport.moistureLevel,delta);
//         finance.incParams('input',transport.culture,delta);
//         transport.shipping(delta,this.bunkerType);
//         if (transport.groupQuantity === 0) {
//             this.checkActiveTransport();
//         }
//     }else{
//         if(delta > 0) {
//             this.filling(transport.culture, transport.wasteLevel, transport.moistureLevel, delta);
//             finance.incParams('input',transport.culture,delta);
//             transport.shipping(delta, this.bunkerType);
//         }
//     }
//
// }else {
//     this.filling(transport.culture,transport.wasteLevel,transport.moistureLevel,sum);
//     transport.shipping(sum,this.bunkerType);
//     finance.incParams('input',transport.culture,sum);
// }


// WEBPACK FOOTER //
// ./src/shared/stores/objects/bunker.js